import { render, staticRenderFns } from "./LogPropertyUserUpdate.vue?vue&type=template&id=ba6629c4&scoped=true&"
import script from "./LogPropertyUserUpdate.vue?vue&type=script&lang=js&"
export * from "./LogPropertyUserUpdate.vue?vue&type=script&lang=js&"
import style0 from "./LogPropertyUserUpdate.vue?vue&type=style&index=0&id=ba6629c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6629c4",
  null
  
)

export default component.exports